export const QUIZ_TYPES = [
    { id: 'QUIZ', name: 'Шалгалт' },
    { id: 'COURSE_QUIZ', name: 'Хичээлийн шалгалт' },
    { id: 'PACKAGE_QUIZ', name: 'Багцын шалгалт' },
  ];
  